import React from 'react';
import {useFormikContext} from 'formik';

export type FormProps = React.FormHTMLAttributes<HTMLFormElement>;

/**
 * Форма, привязанная к ближайшему контексту formik.
 *
 * Замена `Form` из formik: там тип собран через Pick с прибитым списком пропсов React 17,
 * и с типами React 19 он требует несуществующие свойства вроде onPointerEnterCapture.
 * Поведение то же самое, включая action="#" — без него iOS не показывает кнопку отправки.
 */
export const Form = React.forwardRef<HTMLFormElement, FormProps>(function Form({action, ...props}, ref) {
	const {handleReset, handleSubmit} = useFormikContext();

	return <form onSubmit={handleSubmit} onReset={handleReset} action={action ?? '#'} ref={ref} {...props} />;
});
